import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type WithdrawApplicationRequest = {
  eventId: EventType["id"];
};

export type WithdrawApplicationResponse = unknown;

export const withdrawApplication = async (body: WithdrawApplicationRequest): Promise<WithdrawApplicationResponse> => {
  const { data } = await axios.post(`/events/${body.eventId}/withdraw-application`);

  return data;
};
